import {Inject, Injectable, Optional} from '@angular/core';
import {fusion, stripTag} from '@js-dot/core';
import {DotRelativeTimeService} from '@ng-dot/ui/relative-time';
import {BehaviorSubject} from 'rxjs';
import {LayoutModuleConfigure} from '../typings/layout-module-configure';
import {LAYOUT_CONFIGURE} from '../tokens';

@Injectable({
	providedIn: 'root'
})
export class LayoutService {
	protected originTitle!: string;

	configure: LayoutModuleConfigure;

	/**
	 * @deprecated 직접적인 제목 설정을 제한 합니다. `im-title`과 연동 중(enter, exit)
	 */
	heading$ = new BehaviorSubject<string>(null);

	constructor(
		protected _relativeTime: DotRelativeTimeService,
		@Optional() @Inject(LAYOUT_CONFIGURE) configure: LayoutModuleConfigure
	) {
		const documentTitle = document.title;

		this.configure = fusion({
			titles: {
				originTitleGlue: ' - ',
				browserTitleGlue: ' < '
			},
			time: {},
			browserTitle: documentTitle,
			title: documentTitle,
			description: null,
			vendor: documentTitle,
			sinceYear: (new Date).getFullYear(),
			toolbar: {
				position: 'both',
				listFilters: {}
			},
			form: {
				display: 'dialog'
			},
			extended: {
				visible: true
			},
			iconGroup: 'icon24',

			material: {
				formField: {
					appearance: null
				}
			}
		}, configure);

		this._relativeTime.disable = this.configure.time.disableRelativeTime;

		this.setDefault();
	}

	/**
	 * 레이아웃 구성 변수 갱신
	 * @param mapping
	 * @param values
	 */
	update<T extends Record<string, any>, U extends keyof T>(mapping: Partial<Record<keyof LayoutModuleConfigure, U>>, values: Record<U, any>) {
		const {configure} = this;
		for (let key in mapping) {
			if (!mapping.hasOwnProperty(key)) {
				continue;
			}
			const valueKey = mapping[key];
			if (values.hasOwnProperty(valueKey)) {
				const value = values[valueKey];
				if (value) {
					configure[key] = values[valueKey];
				}
			}
		}
		this.setDefault();
	}

	setDefault() {
		this.originTitle = this.configure.browserTitle;
		this.heading$.subscribe(heading => {
			if (heading === this.originTitle) {
				return;
			}
			document.title = heading ?
				stripTag(heading) + this.configure.titles.originTitleGlue + this.originTitle :
				this.originTitle;
		});
	}

	protected tokenComponents = new Map;

	protected setTitle() {
		const {configure: {titles: titleConfigure}} = this;

		if (titleConfigure.disableBrowserTitle === true) {
			return;
		}

		const titles = [];
		for (let [tokenComponents, title] of this.tokenComponents) {
			titles[titles.length] = title;
		}

		const {heading$} = this;

		if (titles.length) {
			if (titleConfigure.disableBrowserTitleFromAll) {
				heading$.next(titles[titles.length - 1]);
			} else {
				if (!titleConfigure.disableBrowserTitleAsDescend) {
					titles.reverse();
				}
				heading$.next(
					titles.join(titleConfigure.browserTitleGlue)
				);
			}
		} else {
			heading$.next(this.originTitle);
		}
	}

	/**
	 * 개별 컴포넌트 진입 및 제목 선언
	 * @param tokenComponent
	 * @param title
	 */
	enter(tokenComponent, title: string) {
		const {tokenComponents} = this;

		tokenComponents.set(tokenComponent, title);

		this.setTitle();
	}

	/**
	 * 개별 컴포넌트 퇴입 선언
	 * @param tokenComponent
	 */

	exit(tokenComponent) {
		const {tokenComponents} = this;

		if (!tokenComponents.has(tokenComponent)) {
			return;
		}

		tokenComponents.delete(tokenComponent);

		this.setTitle();
	}
}
